import * as React from 'react'

export function NoBackgroundScroll<P>(Component: React.ComponentClass<P>): any {
  return class extends React.Component<P> {
    componentDidMount() {
      const body = document.querySelector('body')!
      body.style.overflow = 'hidden'
    }

    componentWillUnmount() {
      const body = document.querySelector('body')!
      body.style.overflow = ''
    }

    render() {
      return <Component {...this.props} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/NoBackgroundScroll/index.tsx